<template>
  <modal-layout add-class="type-b">
    <popup-change-group-delivery :group-list="groupList" @dispose="onDispose" @ok="onDeliveryList"/>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import PopupChangeGroupDelivery from '@/components/modal-popups/PopupChangeGroupDelivery.vue';
export default {
    name: 'ModalChangeGroupDelivery',
    props: {
      groupList: {
        type: Array,
        default: null
      },
      orderKey: {
        type: String,
        default: null
      }
    },
    components: {
        ModalLayout,
        PopupChangeGroupDelivery,
    },
    mixins: [modalMixin],
    methods: {
      onDeliveryList() {
        this.$emit('delivery-change', this.orderKey);
      }
    }
}
</script>